import { render, staticRenderFns } from "./MobilMenuButton.vue?vue&type=template&id=1b489de0&scoped=true"
import script from "./MobilMenuButton.vue?vue&type=script&lang=js"
export * from "./MobilMenuButton.vue?vue&type=script&lang=js"
import style0 from "./MobilMenuButton.vue?vue&type=style&index=0&id=1b489de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b489de0",
  null
  
)

export default component.exports